var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm._m(0),
    _c("div", { staticClass: "right-page" }, [
      _vm._m(1),
      _c("div", { staticClass: "grid-wrap" }, [
        _c("div", { staticClass: "grid" }, [
          _c("div", { staticClass: "button-group" }, [
            _c(
              "div",
              { staticClass: "add-button", on: { click: _vm.createNewForm } },
              [_c("span", [_vm._v("新增問卷")])]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left-page" }, [
      _c("div", { staticClass: "left-item" }, [
        _c("div", { staticClass: "left-search" }, [
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "搜尋問卷標題" },
          }),
        ]),
        _c("div", { staticClass: "left-group" }, [
          _c("span", { staticClass: "left-group-title" }, [_vm._v("問卷群組")]),
        ]),
        _c("div", { staticClass: "left-group-item" }, [
          _c("div", { staticClass: "left-group-title" }, [
            _c("div", { staticClass: "left-group-text" }, [_vm._v("我的問卷")]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right-header" }, [
      _c("div", { staticClass: "right-header-text" }, [
        _c("h4", [_vm._v("我的問卷")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }